/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type AttachBindingRequestBody = {
  principalId: string;
  remoteSessionId: string;
  userSessionIssuerId: string;
};

/** @internal */
export type AttachBindingRequestBody$Outbound = {
  principal_id: string;
  remote_session_id: string;
  user_session_issuer_id: string;
};

/** @internal */
export const AttachBindingRequestBody$outboundSchema: z.ZodMiniType<
  AttachBindingRequestBody$Outbound,
  AttachBindingRequestBody
> = z.pipe(
  z.object({
    principalId: z.string(),
    remoteSessionId: z.string(),
    userSessionIssuerId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      principalId: "principal_id",
      remoteSessionId: "remote_session_id",
      userSessionIssuerId: "user_session_issuer_id",
    });
  }),
);

export function attachBindingRequestBodyToJSON(
  attachBindingRequestBody: AttachBindingRequestBody,
): string {
  return JSON.stringify(
    AttachBindingRequestBody$outboundSchema.parse(attachBindingRequestBody),
  );
}
